import React from "react";
import questionMark from "assets/icons/questionMark.svg";
import description from "assets/icons/description.svg";
import openInNew from "assets/icons/openInNew.svg";
import "./styles.less";
import { useTranslation } from "react-i18next";
import { AppConstants } from "core/app.constants";
import { isUK, translationWrapper } from "utils/common-methods";
import { AccountModal } from "components/AccountModal";
import { WhatIsWorkspace } from "./whatIsWorkspace";


export const LearnMore = (props: any) => {
  const { t } = translationWrapper(useTranslation());
  const [learnMoreSelectedMenu, setLearnMoreSelectedMenu] =
    React.useState<any>("0");
  const [isModalVisible, setIsModalVisible] = React.useState(false);
  const accountModalData = [
    {
      title: t('global.learnmore.title.what_is_workspace'),
      content: (
        <span>
          {t('global.learnmore.content.workspace_is_where_all_your_organizations_farms_etc')}
          <pre />
          {t(`${ isUK() ? 'global.learnmore.content.if_you_are_the_workspace_owner_you_can_edit_plans_uk' : 'global.learnmore.content.if_you_are_the_workspace_owner_you_can_edit_plans_cropwise'}`)}
        </span>
      ),
    },
    {
      title: t('global.learnmore.title.what_is_organization'),
      content: (
        <span>
          {t('global.learnmore.content.the_organization_represents_your_agronomic_business')}
          <pre />
          {t('global.learnmore.content.you_can_have_multiple_farms_in_the_same_organization_and_manage_its_resources_and_members')}
        </span>
      ),
    },
  ];

  const showModal = (key: any) => {
    setIsModalVisible(true);
    setLearnMoreSelectedMenu(key);
  };

  const handleRedirection = (title: any) => {
    const newWindow = window.open(title === 'cropwise' ? AppConstants.LINKS.CROPWISE : AppConstants.LINKS.LEGAL_DOCUMENTS, '_blank', 'noopener,noreferrer');
    if (newWindow) { newWindow.opener = null; }
  };

  const learnMoreListData = [
    {
      icon: questionMark,
      title: t('global.learnmore.title.what_is_workspace'),
      key: "0",
      id: "what_is_workspace",
      handleClick: () => showModal("0"),
    },
    {
      icon: questionMark,
      title: t('global.learnmore.title.what_is_organization'),
      key: "1",
      id: "what_is_organization",
      handleClick: () => showModal("1"),
    },
    {
      icon: description,
      title: t('global.learnmore.title.legal_documents'),
      key: "2",
      id: "legal_documents",
      handleClick: () => handleRedirection("legal documents"),
    }
  ];

  if(!isUK()) {
    learnMoreListData.push({
      icon: openInNew,
      title: t('global.learnmore.title.about_cropwise'),
      key: "3",
      id: "about_cropwise",
      handleClick: () => handleRedirection("cropwise"),
    });
  }

  return (
    <div className="learn-more-container">
      <div className="learn-more-heading">{t('global.learnmore.title.learn_more')}</div>
      {
        props.currentWorkspaceName &&
        <div className="current-workspace-container">
          {t('global.learnmore.title.you_are_in')}{' '}{props.currentWorkspaceName}
        </div>
      }
      <div className="learn-more-content-list">
        {learnMoreListData.map((el) => {
          return (
            <div
              key={el.id}
              className="learn-more-list-item"
              onClick={() => el.handleClick()}
            >
              <div className="learn-more-list-icon">
                <img src={el.icon}></img>
              </div>
              <div className="learn-more-list-title">{el.title}</div>
            </div>
          );
        })}
      </div>
      <AccountModal
        isModalVisible={isModalVisible}
        setIsModalVisible={setIsModalVisible}
        accountModalData={accountModalData[learnMoreSelectedMenu]}
        Image={WhatIsWorkspace}
      />
    </div>
  );
};
